"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typestyle_1 = require("typestyle");

var utils_1 = require("../../utils/utils");

exports.container = function (primaryColor, backgroundColor) {
  return typestyle_1.style({
    borderTop: "2px solid ".concat(primaryColor)
  }, {
    padding: "16px"
  }, {
    backgroundColor: backgroundColor
  });
};

exports.cardTitle = function (fontFamily, color) {
  return typestyle_1.style({
    fontFamily: fontFamily
  }, {
    fontSize: "14px"
  }, {
    fontWeight: 600
  }, {
    marginBottom: "8px"
  }, {
    fontStretch: "normal"
  }, {
    fontStyle: "normal"
  }, {
    lineHeight: "normal"
  }, {
    letterSpacing: "normal"
  }, {
    color: color
  });
};

exports.optionLabel = function (fontFamily, color) {
  return typestyle_1.style({
    fontFamily: fontFamily
  }, {
    color: color
  });
};

exports.cardList = typestyle_1.style({
  paddingLeft: 0
}, {
  display: "flex"
}, {
  flexDirection: "column"
});

exports.cardOption = function (backgroundColor) {
  return typestyle_1.style({
    marginBottom: "15px"
  }, {
    display: "block"
  }, {
    width: "100%"
  }, {
    marginTop: "5px"
  }, {
    marginBottom: "5px"
  }, {
    padding: "5px 20px"
  }, {
    borderRadius: "15px"
  }, {
    border: "1px solid #e8e9f1"
  }, {
    cursor: "pointer"
  }, {
    $nest: {
      "&:hover": {
        backgroundColor: backgroundColor === "#ffffff" ? utils_1.LightenDarkenColor(backgroundColor, -20) : utils_1.LightenDarkenColor(backgroundColor, 50)
      }
    }
  });
};

exports.cardOptionLabel = typestyle_1.style({
  fontSize: "15px"
});

exports.cardOptionValue = function (color) {
  return typestyle_1.style({
    display: "block"
  }, {
    fontSize: "12px"
  }, {
    color: color
  });
};